import { User, DocumentText1, Bank, FolderOpen } from "iconsax-react";
import type { StepItem } from "@/shared/ui";
import type { ContractTab, DocumentTab, ImportWorkerFormValues, ImportWorkerSectionId } from "./types";

export const IMPORT_SECTIONS: (StepItem & { id: ImportWorkerSectionId })[] = [
  { id: "personal", label: "sections.personal", icon: User },
  { id: "contract", label: "sections.contract", icon: DocumentText1 },
  { id: "banking", label: "sections.banking", icon: Bank },
  { id: "documents", label: "sections.documents", icon: FolderOpen },
];

export const DEFAULT_FORM_VALUES: ImportWorkerFormValues = {
  iin: "",
  surname: "",
  name: "",
  father_name: "",
  date_of_birth: null,
  gender: "",
  nationality: "",
  citizenship: "",
  is_resident: true,
  is_student: false,
  enrollment_start_date: null,
  enrollment_end_date: null,
  family_status: "",
  email: "",
  phone: "",
  sign_date: null,
  start_date: null,
  contract_number: "",
  work_city_id: null,
  region_id: undefined,
  employee_address_ru: "",
  employee_address_kk: "",
  job_position_ru: "",
  job_position_kk: "",
  job_duties_ru: [""],
  job_duties_kk: [""],
  working_days_list: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  work_start_time: "09:00",
  work_end_time: "18:00",
  has_break: true,
  break_start_time: "13:00",
  break_end_time: "14:00",
  work_format: "",
  salary_amount: "",
  trial_period: false,
  trial_duration_months: undefined,
  current_vacation_days: "",
  bank_name: "",
  iban_account: "",
  bik_number: "",
  photo_file: null,
  national_id_file: null,
  military_certificate_file: null,
  bank_certificate_file: null,
  enrollment_verification_file: null,
  work_proof_file: null,
  enpf_certificate_file: null,
  diploma_file: [null],
  diploma_transcript_file: [null],
  social_category_document_file: [null],
  contract_file: null,
  job_application_file: null,
  order_on_hiring_file: null,
  personal_sheet_file: null,
  has_no_education: false,
  has_no_work_experience: false,
};

export const SECTION_FIELDS: Record<ImportWorkerSectionId, (keyof ImportWorkerFormValues)[]> = {
  personal: [
    "iin",
    "surname",
    "name",
    "date_of_birth",
    "gender",
    "nationality",
    "email",
    "phone",
    "enrollment_start_date",
    "enrollment_end_date",
  ],
  contract: [
    "sign_date",
    "start_date",
    "job_position_ru",
    "job_position_kk",
    "job_duties_ru",
    "job_duties_kk",
    "salary_amount",
    "work_start_time",
    "work_end_time",
    "working_days_list",
    "work_format",
    "employee_address_ru",
    "employee_address_kk",
    "region_id",
  ],
  banking: [
    "bank_name",
    "iban_account",
    "bik_number",
  ],
  documents: [
    "contract_file",
    "job_application_file",
    "order_on_hiring_file",
    "photo_file",
    "national_id_file",
    "bank_certificate_file",
    "work_proof_file",
    "military_certificate_file",
    "enrollment_verification_file",
    "diploma_file",
    "diploma_transcript_file",
    "social_category_document_file",
  ],
};

export const GENDER_OPTIONS = [
  { value: "male", labelKey: "personal.genderMale" },
  { value: "female", labelKey: "personal.genderFemale" },
];

export const WORK_FORMAT_OPTIONS = [
  { value: "onsite", labelKey: "contract.workFormatValues.onsite" },
  { value: "remote", labelKey: "contract.workFormatValues.remote" },
  { value: "hybrid", labelKey: "contract.workFormatValues.hybrid" },
];

export const CONTRACT_TAB_FIELDS: Record<ContractTab, string[]> = {
  info: ["sign_date", "start_date", "region_id", "employee_address_ru", "employee_address_kk"],
  position: ["job_position_ru", "job_position_kk", "job_duties_ru", "job_duties_kk"],
  schedule: [
    "work_start_time",
    "work_end_time",
    "working_days_list",
    "work_format",
    "salary_amount",
    "trial_duration_months",
    "break_start_time",
    "break_end_time",
  ],
};

export const DOCUMENT_TAB_FIELDS: Record<DocumentTab, string[]> = {
  contract: ["contract_file", "job_application_file", "order_on_hiring_file"],
  personal: [
    "photo_file",
    "national_id_file",
    "bank_certificate_file",
    "work_proof_file",
    "military_certificate_file",
    "enrollment_verification_file",
    "diploma_file",
    "diploma_transcript_file",
    "social_category_document_file",
  ],
};

export const FLAT_STEPS: { section: ImportWorkerSectionId; tab: string | null }[] = [
  { section: "personal", tab: null },
  { section: "contract", tab: "info" },
  { section: "contract", tab: "position" },
  { section: "contract", tab: "schedule" },
  { section: "banking", tab: null },
  { section: "documents", tab: "contract" },
  { section: "documents", tab: "personal" },
];
